import React from "react";

import Popup from "./Popup";

const PopupSelectPhone = props => {
  const { trigger, setTrigger, children, width } = props;

  return (
    <Popup width={width} title="Selecionar telefone" trigger={trigger} setTrigger={setTrigger}>
      <div className="sm-body">
        {children}
      </div>
    </Popup>
  );
}

export default PopupSelectPhone;